import { motion } from "framer-motion";

const steps = [
  {
    num: "01",
    title: "Say hello",
    desc: "A WhatsApp message or the form below. We learn your brand, category and goals in one conversation.",
  },
  {
    num: "02",
    title: "Audit & roadmap",
    desc: "Within 48 hours you get a platform-by-platform launch plan — costs, timelines and what moves the needle first.",
  },
  {
    num: "03",
    title: "Setup & go live",
    desc: "Accounts, catalogs, content and compliance built for you. Most brands go live in 7–14 days.",
  },
  {
    num: "04",
    title: "Scale & optimize",
    desc: "Weekly reporting, listing optimization and optional ads management as your orders grow.",
  },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-28 lg:py-40 bg-ink border-y border-coal/10"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="flex items-start justify-between mb-16 lg:mb-24">
          <div>
            <motion.span
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-xs font-bold uppercase tracking-[0.25em] text-coal/40"
            >
              02 — How it works
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="font-display font-900 tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-xl"
            >
              From first message to{" "}
              <span className="font-accent italic font-medium text-terracotta">
                first order.
              </span>
            </motion.h2>
          </div>
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="hidden lg:block font-display font-900 text-8xl text-outline-gold select-none"
          >
            02
          </motion.span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-coal/10 border border-coal/10">
          {steps.map((step, i) => (
            <motion.div
              key={step.num}
              data-testid={`process-step-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.8,
                delay: i * 0.12,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="group bg-ink p-8 lg:p-10 hover:bg-steel transition-colors duration-500"
            >
              <span className="font-display font-900 text-6xl text-outline-gold group-hover:text-gold transition-colors duration-500 select-none">
                {step.num}
              </span>
              <h3 className="font-display font-800 text-xl sm:text-2xl tracking-tight mt-8">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-coal/55">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
